import { render, staticRenderFns } from "./PendingTrainingsCard.vue?vue&type=template&id=f3f977a0"
import script from "./PendingTrainingsCard.vue?vue&type=script&lang=js"
export * from "./PendingTrainingsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports